import '../styles.css'

export function rowStyleClasses (cellParams) {
  const classes = []

  if (cellParams.data.formulaAlaSQLOperator === 'divide') {
    classes.push('fs-ratio')
  } else if (cellParams.data.formulaAlaSQL) {
    classes.push('fs-sum')
  }

  if (cellParams.data.level === 1) {
    classes.push('fs-details')
  }

  if (cellParams.context?.showDebug) {
    console.log('rowStyleClasses', classes)
  }
  return classes
}
